export default {
    urls: {
        app: "https://app.mystorytime.com",
        marketing: "https://mystorytime.com",
    },
    auth: {
        signInOptions: [
            {
                clientId: "498216966416-k7rdu5h1k5915srj8orl4aec6pjkuben.apps.googleusercontent.com",
            },
        ],
        tosUrl: "https://mystorytime.com/tos",
        privacyPolicyUrl: "https://mystorytime.com/privacy",
    },
    firebase: {
        apiKey: "AIzaSyCvkwWuTkiXYowBiSdwIYm7V038VrW_TFw",
        authDomain: "auth.app.mystorytime.com",
        databaseURL: "https://storytime-7c623.firebaseio.com",
        projectId: "storytime-7c623",
        storageBucket: "storytime-7c623.appspot.com",
        messagingSenderId: "498216966416",
        appId: "1:498216966416:web:24de41a6cad4c26275ed95",
        measurementId: "G-LQYZVZNZBX",
    },
};
//# sourceMappingURL=production.js.map